import React from 'react';
import {
  FormPageInputItemMailAddress,
  FormPageInputItemMailAddressAtSignSeparated,
  FormPageInputItemMailAddressFree,
  MailAddressProperty,
  MailAddressPropertyAtSignSeparated,
  MailAddressPropertyDomainPulldown,
  MailAddressPropertyFree,
  MAIL_ADDRESS_PROPERTY_INPUT_TYPE,
  FormPageInputItemMailAddressDomainPulldown,
} from 'shared';
import { FormFieldInputProps, hasErrorMessage } from '../shared';
import { MailAddressAtSignSeparated } from './MailAddressAtSignSeparated';
import { MailAddressDomainPulldown } from './MailAddressDomainPulldown';
import { MailAddressFree } from './MailAddressFree';

export type MailAddressInputProps = FormFieldInputProps<
  MailAddressProperty,
  FormPageInputItemMailAddress
>;

const isError = (
  errorMessages: MailAddressInputProps['errorMessages'],
  displayError = false,
): boolean => !!displayError && hasErrorMessage(errorMessages);

export const MailAddressInput: React.FC<MailAddressInputProps> = (props) => {
  switch (props.property.inputFormat.inputType) {
    case MAIL_ADDRESS_PROPERTY_INPUT_TYPE.free: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          MailAddressPropertyFree,
          FormPageInputItemMailAddressFree
        >;
      const displayError = submitted || (touched && touched.mailAddress);
      return (
        <MailAddressFree
          mailAddress={value.mailAddress}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case MAIL_ADDRESS_PROPERTY_INPUT_TYPE.atSignSeparated: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          MailAddressPropertyAtSignSeparated,
          FormPageInputItemMailAddressAtSignSeparated
        >;
      const displayError =
        submitted || (touched && touched.local && touched.domain);
      return (
        <MailAddressAtSignSeparated
          local={value.local}
          domain={value.domain}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
    case MAIL_ADDRESS_PROPERTY_INPUT_TYPE.domainPulldown: {
      const { submitted, touched, errorMessages, value, ...baseProps } =
        props as FormFieldInputProps<
          MailAddressPropertyDomainPulldown,
          FormPageInputItemMailAddressDomainPulldown
        >;
      const displayError =
        submitted || (touched && touched.local && touched.domain);
      return (
        <MailAddressDomainPulldown
          local={value.local}
          domain={value.domain}
          displayError={isError(errorMessages, displayError)}
          errorMessages={errorMessages}
          {...baseProps}
        />
      );
    }
  }
};
